/**
 * consoleStyle
 */

import { escapeHtml } from '../../scripts/richtext';

export default {
  getErr: (msg) => {
    return `<span style="color: #FF0000">${msg}</span>`
  },
  getWarn: (msg) => {
    return `<span style="color: #FF800A">${msg}</span>`
  },
  getRun: (msg) => {
    return `<span style="color: #42b983">${msg}</span>`
  },
  getTest: (msg) => {
    return `<span style="color: #42b983">${msg}</span>`
  },
  getSave: (msg) => {
    return `<span style="color: #42b983">${msg}</span>`
  },
  getCommit: (msg) => {
    return `<span style="color: #42b983">${msg}</span>`
  },
  getSuccess: (msg) => {
    return `<span style="color: #42b983">${msg}</span>`
  },
  getInput: (msg) => {
    return `<span style="color: #42b983">${msg}</span>`
  },
  getOutput: (msg) => {
    return `${escapeHtml(msg)}`
  },
  getLineTime: (msg) => {
    return `<span style="color: #42b983">${msg}</span>`
  },
};
